import apiClient from '../../utils/apiClient';
import { workspaceService } from '../../api/services';

class EventsService {
  async getUserEvents(email) {
    return await workspaceService.getUserEvents(email);
  }

  async getEventAttendees(eventId, email) {
    return await workspaceService.getEventAttendees(eventId, email);
  }

  async getTodayEvents(email) {
    const response = await this.getUserEvents(email);
    const eventsData = response.data.data || response.data || [];
    
    const today = new Date();
    const todayStr = today.toISOString().split('T')[0];
    
    return eventsData.filter(event => {
      const eventDate = event.start?.dateTime || event.start?.date;
      if (!eventDate) return false;
      
      const eventDateStr = new Date(eventDate).toISOString().split('T')[0];
      return eventDateStr === todayStr;
    });
  }

  async createOrUpdateEvent(eventData, organizer_name) {
    const response = await apiClient.post(`/eventos/crear-o-actualizar/?user_email=${organizer_name}`, {
      ...eventData,
      force_update: true
    });
    
    if (response.ok) {
      const data = await response.json();
      if (data.success && data.event_id) {
        return data.event_id;
      }
    }
    
    return null;
  }

  async getEventByGoogleId(googleEventId) {
    const response = await apiClient.get(`/eventos/buscar-por-google-id/${encodeURIComponent(googleEventId)}/`);
    
    if (response.ok) {
      const data = await response.json();
      if (data.success && data.event_id) {
        return data.event_id;
      }
    }
    
    return null;
  }

  async getOrCreateEvent(googleEventId, eventDetails) {
    try {
      // Convertir fechas de Google Calendar a objetos Date simples
      const startTime = eventDetails.start?.dateTime || eventDetails.start?.date || eventDetails.start;
      const endTime = eventDetails.end?.dateTime || eventDetails.end?.date || eventDetails.end;
      const organizer_name = eventDetails.organizer_name || '';
      const eventData = {
        google_event_id: googleEventId,
        title: eventDetails.title || eventDetails.summary || 'Evento sin título',
        start_time: startTime instanceof Date ? startTime : new Date(startTime),
        end_time: endTime instanceof Date ? endTime : new Date(endTime),
        location: eventDetails.resource?.location || '',
        description: eventDetails.resource?.description || ''
      };
      
      let eventDbId = await this.createOrUpdateEvent(eventData, organizer_name);
      
      if (!eventDbId) {
        eventDbId = await this.getEventByGoogleId(googleEventId);
      }
      
      return eventDbId;
    } catch (error) {
      console.error('Error al obtener/crear evento:', error.message);
      return null;
    }
  }

  async validateEventGuests(eventId, invitados) {
    const response = await apiClient.post(`/eventos/${encodeURIComponent(eventId)}/validar-invitados/`, { invitados });
    
    const data = await response.json();
    
    if (response.ok) {
      return data;
    }
    
    // Manejar errores del backend
    const errorMessage = data.message || data.error || `Error HTTP ${response.status}`;
    throw new Error(errorMessage);
  }
}

export default new EventsService();